import cookies from 'js-cookie'
import config from '@/config'

/**
 * 애플 기기 여부 체크
 * @returns true|false
 */
export function isAppleDevice () {
    let userAgent = navigator.userAgent.toLocaleLowerCase()
    if (userAgent.indexOf('iphone') > -1 || userAgent.indexOf('ipad') > -1) {
      return true
    } else {
      return false
    }
}

/**
 * 웹 공용 뒤로가기 액션
 */
export function historyPage (isForceClose) {
  if (window.location.pathname === '/' || isForceClose) {
    console.log('EXIT')
    commonAppCall('EXIT')
  } else if (window.location.search.indexOf('direct=1') > -1) {
    console.log('EXIT')
    commonAppCall('EXIT')
  } else {
    console.log('history.back()')
    history.back()
  }
}

/**
 * 현재 브라우져가 아닌 신규 브라우져 띄움
 * @param { String } outLinkUrl url 링크
 */
export function appOutLink (outLinkUrl) {
  // if (cookies.get('fromMobileApp') === 'true') {
  let data = {
    'ViewCode': 3,
    'OutLinkURL': outLinkUrl
  }
  console.log(JSON.stringify(data))
  commonAppCall(data, true)
  // } else {
  //   window.open(outLinkUrl, '_blank')
  // }
}

/**
 * 랜딩 정보 생성 및 전송
 * @param { Object } rendingInfo 랜딩 데이터
 */
export function appLanding (rendingInfo) {
  let data = {
    'ViewCode': rendingInfo.viewCode,
    'RendingCode': rendingInfo.rendingCode,
    'RendingData': rendingInfo.rendingData
  }

  console.log(JSON.stringify(data))
  commonAppCall(data, true)
}

/**
 * 앱으로 랜딩 정보 전송
 * @param { Object } data 랜딩 데이터
 * @param { boolean } isAllowStringify Stringify 필요 여부
 * @returns 
 */
export function commonAppCall (data, isAllowStringify) {
  if (config.isLocalDevelopment) return

  let userAgent = navigator.userAgent.toLocaleLowerCase()
  let jsonStringfyData = null

  if (isAllowStringify) {
    jsonStringfyData = JSON.stringify(data)
  } else {
    jsonStringfyData = data
  }

  if (userAgent.indexOf('iphone') > -1 || userAgent.indexOf('ipad') > -1) {
    return window.webkit.messageHandlers.handleAppGuide.postMessage(jsonStringfyData)
  } else {
    return window.handleAppGuide.callAndroid(jsonStringfyData)
  }
}

/**
 * 유효기간 1년으로 쿠키값 저장
 * @param { String } key 
 * @param { * } value 
 */
export function setCookieForYear (key, value) {
  // App 정보는 만료시간 360일 후 설정
  const expAppInfo = new Date();
  expAppInfo.setTime(expAppInfo.getTime() + 1000 * 60 * 60 * 24 * 30 * 12)
  cookies.set(key, value, { 'expires': expAppInfo })
}